import { useGetConfigQuery } from '@common/config';

export function useConfig<T extends {}>() {
  const { data: config } = useGetConfigQuery();

  return {
    config: config as T,
    getConfigValue: (key: keyof T) => config[key] || `[Texte à définir ("${key}")]`,
  };
}